<template lang="pug">
  .akay
    p {{$('login.title')}}
</template>

<script>
export default {
  name: 'test',
  data () {
    return {
      locale: 'en'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test.vue